var scaleCorrectors={};function addScaleCorrector(correctors){Object.assign(scaleCorrectors,correctors);}export{addScaleCorrector,scaleCorrectors};